import Manager from 'coreClasses/Manager';
import GeolocationProvider from './providers/GeolocationProvider';
import {TGeolocationResponse} from './IGeolocation';
import GeolocationProvidersMgr from 'coreClasses/geolocation/GeolocationProvidersMgr';

/**
 * Represents GeolocationMgr
 */
class GeolocationMgr extends Manager {
	/**
	 * Returns Geolocation provider
	 * @param {String|null} providerId Provider Id
	 * @returns {GeolocationProvider}
	 */
	private getGeolocationProvider(providerId?: string): GeolocationProvider {
		if (!providerId) {
			providerId = this.managerRepository.getConfigurationsMgr().get('sitePreferences.geolocationProvider');
		}

		return GeolocationProvidersMgr.getProvider(providerId);
	}

	/**
	 * Returns geolocation
	 * @returns { Promise<TGeolocationResponse>} geolocation
	 */
	public async getGeolocation(): Promise<TGeolocationResponse> {
		return await this.getGeolocationProvider().getGeolocation();
	}
}

export default GeolocationMgr;
